<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Gestion de la tâche planifié pour la relance décès</strong>
          </div>
          <b-form>
            <b-row>
              <b-col md="4">
                <b-row class="mb-1">
                  <b-col sm="6">
                    <label for="cron"><strong>Activer la tâche planifiée :</strong></label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-checkbox id="cron" v-model="cronActif" name="check-button" switch></b-form-checkbox>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="8">
                <b-row class="mb-1">
                  <b-col sm="8">
                    <label for="dateReceptionDossier"><strong>Date de réception des dossiers à partir de laquelle le script doit réveiller les dossiers</strong></label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input class="input_date" type="date" id="dateReceptionDossier" size="sm" v-model="dateReceptionDossier" :class="{hasError: errors.dateReceptionDossier !== ''}"></b-form-input>
                    <span class="field-error inline mr-1 float-right">{{ errors.dateReceptionDossier }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
          <b-row>
            <b-col md="12">
              <div class="mt-5" slot="footer">
                <b-button type="button" @click="save" size="md" class="pull-right" variant="primary">
                  <i class="fa fa-save"/> Enregistrer
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {isEmpty} from "@/utils/fileHelper";
  import { formatDateTime } from "@/utils/communHelper";

  export default {
    name: "AddCodeBarre",
    data() {
      return {
        formatDateTime,
        cronActif: false,
        dateReceptionDossier: '',
        errors: {
          dateReceptionDossier: '',
        },
      }
    },
    created() {
      this.getInfosCron();
    },
    methods: {
      save() {
        if (this.validateData()) {
          let self = this;
          this.$store.commit("IS_LOADING", true);
          let dataPost = {};
          dataPost.dateReceptionDossier = this.dateReceptionDossier;
          dataPost.cronActif = this.cronActif;
          dataPost.tache = 'relance_dc';
          this.$axios
            .post("/cron-relance-deces", dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Succès",
                text: "Les informations ont été correctement enregistrées",
                showConfirmButton: false,
                timer: 5000
              });
              this.getInfosCron()
            })
            .catch((error) => {
              self.$store.commit("IS_LOADING", false);
              self.handleError(error);
            });
        }
      },
      getInfosCron() {
        let self = this;
        this.$store.commit('IS_LOADING', true);

        this.$axios
          .get('/cron-relance-deces/relance_dc')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            this.dateReceptionDossier = response.data.cron.date;
            this.cronActif = response.data.cron.is_active;
          })
          .catch((error) => {
            self.$store.commit('IS_LOADING', false);
            self.handleError(error);
          });
      },
      validateData() {
        this.clearErrors()
        let valid = true;
        
        if (this.cronActif) {
          if (isEmpty(this.dateReceptionDossier)) {
            this.errors.dateReceptionDossier = 'Vous ne pouvez activer la tâche planifiée sans définir de date';
            valid = false;
          }
        }
        return valid;
      },
      clearErrors() {
        this.errors.codeBarre = "";
      },
      handleError(error) {
        let text = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
        let type = 'error';
        if (!isEmpty(error) && error.response && error.response.status === 403) {
          text = 'Vous n\'avez pas le droit d\'enregistrer un code barre';
        } else if (!isEmpty(error) && error.response && error.response.status === 424) {
          text = error.response.data.message;
          type = 'warning';
        }
        this.$swal({
          position: 'top',
          type: type,
          title: 'Attention !!',
          text: text,
          showConfirmButton: false,
          timer: 5000
        });
      },
    }
  }
</script>
